import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import { createRouter, createWebHistory } from 'vue-router';

// Routes
import pages from './routes/pages'
import scisaViews from './routes/scisaViews'

const routes = [
  { path: '/', redirect: { name: 'home' } },
  ...pages,
  ...scisaViews,
  {
    path: '/:pathMatch(.*)*',
    redirect: 'error-404',
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  // Rutas privadas por defecto: solo las marcadas con meta.public son accesibles
  // sin sesión (login, callbacks, páginas de error/misc). Se usa `to.matched` para
  // que las rutas hijas hereden el flag público de su ruta padre.
  const isPublic = to.matched.some(record => record.meta.public)

  // Si ya hay sesión y la ruta es solo para invitados, llevar a la home del usuario
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    return next(getHomeRouteForLoggedInUser(userData ? userData.profile : null))
  }

  // Bloquear acceso a rutas privadas sin sesión activa
  if (!isPublic && !isLoggedIn) {
    return next({ name: 'auth-login' })
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
